import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ToolActions from '../../../actions/tools/ToolActions';
import * as OrdersSearchActions from '../../../actions/tools/OrdersSearchActions';
import CommonSelectTask from '../../../components/tools/CommonSelectTask/CommonSelectTask';
import { getOrderModificationsAreAllowed } from '../../../selectors/tools';
import * as ToolsSelectors from '../../../selectors/tools';
import get from 'lodash/get';
import { isSpecialist, getSelectedOrderFromOrdersSearch } from '../../../extractFromState';

const TASK_INPUTS = [
  {
    id: 'orderDetails',
    title: 'Order Summary',
  },
  {
    id: 'cancelOrder',
    title: 'Cancel Order',
    conditionFunc: (order, state) => {
      return allowsCancellation(state) && getOrderModificationsAreAllowed(state);
    },
  },
  {
    id: 'refundOrder',
    title: 'Refund Order',
    conditionFunc: (order, state) => {
      return allowsRefund(state) && getOrderModificationsAreAllowed(state);
    },
  },
  {
    id: 'refundStoreCredit',
    title: 'Issue store credit',
    conditionFunc: (order, state) => {
      return allowsRefundStoreCredit(state) && getOrderModificationsAreAllowed(state);
    },
  },
  {
    id: 'updateShipmentAddress',
    dataProtected: true,
    sensitiveDataType: 'shipping address',
    title: 'Update Shipment Address',
    conditionFunc: (order, state) => {
      return allowsUpdateAddress(state) && getOrderModificationsAreAllowed(state);
    },
  },
];

function allowsRefund(state) {
  return allowsToFeature(state, 'allowRefund');
}

function allowsRefundStoreCredit(state) {
  return allowsToFeature(state, 'allowRefundStoreCredit');
}

function allowsCancellation(state) {
  return allowsToFeature(state, 'allowCancellation');
}

function allowsUpdateAddress(state) {
  return allowsToFeature(state, 'allowUpdateShipmentAddress');
}

function getSimplrOrderConfig(state) {
  const configs = ToolsSelectors.getSimplrorderConfigs(state) || {};
  const domain = getSelectedOrderFromOrdersSearch(state).domain;

  return configs[domain] || {};
}

function allowsToFeature(state, access) {
  const config = getSimplrOrderConfig(state);
  const allows = get(config, access, []);
  const specialist = isSpecialist(state);

  const canOpenSpecialist = specialist && allows.includes('specialist');
  const canOpenExpert = !specialist && allows.includes('expert');

  return canOpenSpecialist || canOpenExpert;
}

const mapStateToProps = (state) => {
  const selectedOrder = getSelectedOrderFromOrdersSearch(state);
  const taskInputsToShow = TASK_INPUTS.filter((taskInput) => {
    return taskInput.conditionFunc ? taskInput.conditionFunc(selectedOrder, state) : true;
  });

  return {
    taskInputs: taskInputsToShow,
    selectedToolDomains: state.tools.general.selectedToolDomains,
    domain: selectedOrder.domain || null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(Object.assign({}, ToolActions, OrdersSearchActions), dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CommonSelectTask);
